var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import styles from './ExternalProviderButton.module.scss';
import { Route, Switch, withRouter } from 'react-router-dom';
import { action, observable } from 'mobx';
import { UpdateTaskModal } from '@app/Widgets/ManualTaskModals/UpdateTaskModal';
import { AddTaskModal } from '@app/Widgets/ManualTaskModals/AddTaskModal';
import { AppData, StatusEnum } from '@app/AppConstants';
import { colorThemesStore } from '@app/Stores/ColorThemesStore';
var ExternalProviderButtonComponent = /** @class */ (function (_super) {
    __extends(ExternalProviderButtonComponent, _super);
    function ExternalProviderButtonComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isAddTaskModalOpen = false;
        _this.getBGColor = function () {
            var _a = _this.props, taskId = _a.taskId, taskStatus = _a.taskStatus;
            var colors = colorThemesStore.appColors;
            if (taskId == null && !taskStatus) {
                return colors.gray;
            }
            else {
                if (taskStatus === StatusEnum.Approved) {
                    return colors.green;
                }
                else if (taskStatus === StatusEnum.InApproval)
                    return colors.orange;
                else
                    return colors.yellow;
            }
        };
        return _this;
    }
    ExternalProviderButtonComponent.prototype._closeMeetingModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, history, match;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, history = _a.history, match = _a.match;
                        return [4 /*yield*/, this.props.onRefresh()];
                    case 1:
                        _b.sent();
                        history.push("".concat(match.url));
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalProviderButtonComponent.prototype._toggleAddTaskModal = function () {
        this._isAddTaskModalOpen = !this._isAddTaskModalOpen;
    };
    ExternalProviderButtonComponent.prototype.afterAddTask = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._toggleAddTaskModal();
                        return [4 /*yield*/, this.props.onRefresh()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalProviderButtonComponent.prototype.handleDelegateClick = function () {
        var _a = this.props, history = _a.history, match = _a.match, taskId = _a.taskId;
        if (taskId) {
            history.push("".concat(match.url, "/tsk-").concat(taskId));
        }
        else {
            this._toggleAddTaskModal();
        }
    };
    ExternalProviderButtonComponent.prototype.render = function () {
        var _a = this.props, match = _a.match, location = _a.location, taskId = _a.taskId, projectId = _a.projectId, projectName = _a.projectName, gateId = _a.gateId, gateCodeName = _a.gateCodeName, checkListItemId = _a.checkListItemId, disable = _a.disable;
        var lastIndexTaskInUrl = location.pathname.lastIndexOf(AppData.TaskUrlPart);
        var hasTaskInUrl = lastIndexTaskInUrl !== -1;
        var urlTaskId = 0;
        if (hasTaskInUrl) {
            var slashIndex = location.pathname.indexOf('/', lastIndexTaskInUrl);
            urlTaskId = Number(location.pathname.substring(lastIndexTaskInUrl + 4, slashIndex !== -1 ? slashIndex : location.pathname.length));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: !disable ? styles.button : styles.disableButton, style: { backgroundColor: this.getBGColor() }, title: "Delegate", onClick: this.handleDelegateClick }, "D"),
            this._isAddTaskModalOpen && (React.createElement(AddTaskModal, { projectId: projectId, projectName: projectName, gateId: gateId, gateCodeName: gateCodeName, checkListItemId: checkListItemId, afterSave: this.afterAddTask, onToggle: this._toggleAddTaskModal, isOpen: this._isAddTaskModalOpen })),
            React.createElement(Switch, null,
                React.createElement(Route, { path: "".concat(match.url, "/tsk-:id") }, taskId && urlTaskId && taskId === urlTaskId && (React.createElement(UpdateTaskModal, { backUrl: match.url, onToggle: this._closeMeetingModal }))))));
    };
    __decorate([
        observable
    ], ExternalProviderButtonComponent.prototype, "_isAddTaskModalOpen", void 0);
    __decorate([
        action.bound
    ], ExternalProviderButtonComponent.prototype, "_closeMeetingModal", null);
    __decorate([
        action.bound
    ], ExternalProviderButtonComponent.prototype, "_toggleAddTaskModal", null);
    __decorate([
        action.bound
    ], ExternalProviderButtonComponent.prototype, "afterAddTask", null);
    __decorate([
        action.bound
    ], ExternalProviderButtonComponent.prototype, "handleDelegateClick", null);
    ExternalProviderButtonComponent = __decorate([
        observer
    ], ExternalProviderButtonComponent);
    return ExternalProviderButtonComponent;
}(React.Component));
export var ExternalProviderButton = withRouter(ExternalProviderButtonComponent);
